/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { assumeNonNull as t } from "../core/maybe.js";
import { beforeLocaleChange as n, getLocale as r } from "./locale.js";
var a = {
  ar: "ar-u-nu-latn"
};
var e = new WeakMap(),
    o = {};

function i(n) {
  var i = n || o;

  if (!e.has(i)) {
    var _t = r(),
        _o = a[r()] || _t;

    e.set(i, new Intl.NumberFormat(_o, n));
  }

  return t(e.get(i));
}

function u() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var n = {};
  return null != t.digitSeparator && (n.useGrouping = t.digitSeparator), null != t.places && (n.minimumFractionDigits = n.maximumFractionDigits = t.places), n;
}

function m(t, n) {
  return i(n).format(t);
}

n(function () {
  e = new WeakMap(), o = {};
});
export { u as convertNumberFormatToIntlOptions, m as formatNumber, i as getFormatter };